export const activities = [
  {
    id: "water-sports",
    title: "WATER SPORTS AND BEACH ACTIVITIES",
    items: [
      { text: "Parasailing at Muzhappilangad Beach - India's longest drive-in beach offering thrilling aerial views", hasUrl: false },
      { text: "Swimming at Payyambalam Beach - Clean golden sands perfect for family beach activities", hasUrl: false },
      { text: "Beach driving experience at Muzhappilangad - Drive your car directly on the beach for 4km", hasUrl: false },
      { text: "Surfing and windsurfing lessons - Professional instructors available during peak season", hasUrl: false },
      { text: "Deep sea fishing with local fishermen - Traditional fishing experience with authentic Kerala boats", hasUrl: false },
      { text: "Beach volleyball and football - Evening games with locals and tourists", hasUrl: false },
      { text: "Kayaking through backwater channels - Explore hidden waterways and mangrove forests", hasUrl: false },
      { text: "Dolphin watching tours - Early morning boat trips to spot playful dolphins", hasUrl: false }
    ]
  },
  {
    id: "cultural-experiences",
    title: "CULTURAL EXPERIENCES",
    items: [
      { text: "Watch traditional Theyyam performances - Sacred ritual art form unique to North Kerala", url: "https://travelkannur.com/theyyam-calender/", hasUrl: true },
      { text: "Visit ancient temples and mosques - Explore centuries-old religious architecture", url: "https://www.keralatourism.org/malabar/pilgrim-centres/125", hasUrl: true },
      { text: "Portuguese and British colonial architecture tour - Walk through historic Fort Road and cantonment areas", hasUrl: false },
      { text: "Local festival celebrations - Experience Onam, Vishu, and regional harvest festivals", hasUrl: false },
      { text: "Handloom weaving village visits - Learn traditional Kerala weaving techniques", url: "https://www.keralatourism.org/thalassery/tourist-circuits/culture/azhikode-handloom-village", hasUrl: true },
      { text: "Spice plantation tours - Discover cardamom, pepper, and cinnamon cultivation methods", hasUrl: false },
      { text: "Traditional cooking classes - Learn to prepare authentic Malabar cuisine with local families", hasUrl: false }
    ]
  },
  {
    id: "adventure-activities",
    title: "ADVENTURE ACTIVITIES",
    items: [
      { text: "Western Ghats trekking expeditions - Multi-day treks through pristine forest trails", url: "https://travel.india.com/guide/destination/top-trekking-destinations-in-kannur-for-adventure-seekers-7495236/", hasUrl: true },
      { text: "Backwater cruises on traditional houseboats - Overnight stays available", url: "https://kannurtravels.com/backwater-activities-in-kannur/", hasUrl: true },
      { text: "Island hopping adventures - Visit Dharmadam Island and nearby uninhabited islands", url: "https://www.keralatourism.org/destination/dharmadam-island-kannur/89/", hasUrl: true },
      { text: "Coastal cycling tours - Guided rides through fishing villages and coconut groves", hasUrl: false },
      { text: "Rock climbing at Ezhimala Hills - Natural rock formations perfect for beginners", hasUrl: false },
      { text: "Wildlife photography at Aralam Sanctuary - Spot elephants, tigers, and exotic birds", hasUrl: false },
      { text: "River rafting on Valapattanam River - Seasonal white water rafting during monsoons", hasUrl: false }
    ]
  },
  {
    id: "historic-sightseeing",
    title: "HISTORIC SIGHTSEEING",
    items: [
      { text: "St. Angelo Fort - 16th century Portuguese fortress with sea views", url: "https://maps.app.goo.gl/fhXGoUdWEoU7jX9T6", hasUrl: true },
      { text: "Arakkal Museum - Unique maritime heritage of Kerala's only Muslim royal family", url: "https://maps.app.goo.gl/2fAb6pN52nJ3ixcT8", hasUrl: true },
      { text: "Kannur Lighthouse - 150-year-old lighthouse with panoramic coastal views", url: "https://maps.app.goo.gl/xixYSXAtj9XaFE4U8", hasUrl: true },
      { text: "Pazhayangadi Mosque - Stunning Indo-Islamic architecture from 14th century", url: "https://www.dtpckannur.com/destination/madayi-mosque", hasUrl: true },
      { text: "Taliparamba Rajarajeshwara Temple - 1000-year-old temple with intricate wood carvings", url: "https://en.wikipedia.org/wiki/Rajarajeshwara_Temple", hasUrl: true },
      { text: "Ezhimala Naval Academy - Training center with beautiful coastal campus (external viewing)", hasUrl: false },
      { text: "Madayi Para - Hilltop archaeological site with ancient cave paintings", hasUrl: false }
    ]
  }
];

export const food = [
  {
    id: "malabar-cuisine",
    title: "AUTHENTIC MALABAR CUISINE",
    items: [
      { text: "Malabar Fish Curry - Coconut-based curry with fresh catch of the day served with appam or rice", hasUrl: false },
      { text: "Thalassery Biryani - Fragrant short-grain rice cooked with tender mutton in traditional Dum style", hasUrl: false },
      { text: "Pathiri and Kozhi Curry - Soft rice pancakes served with spicy chicken curry", hasUrl: false },
      { text: "Kallummakkaya Ularthiyathu - Stir-fried mussels with coconut and spices", hasUrl: false },
      { text: "Nei Choru - Ghee rice preparation unique to North Malabar region", hasUrl: false },
      { text: "Unnakkai - Sweet dumpling filled with banana, coconut, and nuts", hasUrl: false }
    ]
  },
  {
    id: "must-visit-restaurants",
    title: "MUST-VISIT RESTAURANTS",
    items: [
      { text: "Hotel Odhens - Famous for traditional Malabar fish dishes and seafood specialties", url: "https://www.tripadvisor.com.au/Restaurant_Review-g777115-d3636681-Reviews-Hotel_Odhen_s-Kannur_Kannur_District_Kerala.html", hasUrl: true },
      { text: "Biryani Hotel Soft - Renowned for authentic Thalassery biryani and mutton dishes", url: "https://maps.app.goo.gl/aKZdFSBtYQJwBxiM3", hasUrl: true },
      { text: "MVK Biryani - Local favorite for flavorful biryani and traditional Kerala meals", url: "https://maps.app.goo.gl/nrRzeOU2VyOT4PyNR", hasUrl: true },
      { text: "Kannur Beach Restaurant - Beachside dining with fresh seafood and Malabar specialties", url: "https://maps.app.goo.gl/Lo5wtI3N0txpvdjxZ", hasUrl: true },
      { text: "Malabar Palace Restaurant - Upscale dining with traditional and contemporary Kerala cuisine", url: "https://maps.app.goo.gl/ypAGpsmjE9gaxGbk6", hasUrl: true },
      { text: "Coastal Spice Kitchen - Family restaurant known for home-style Malabar cooking", url: "https://maps.app.goo.gl/aZex46vRfk1nE9LR9", hasUrl: true }
    ]
  }
];

export const combinedActivities = [...activities, ...food];
